export default {"src":"/_next/static/media/copy-link.a23a0caf.svg","height":21,"width":17};